import Option from "../../entities/option";

/**
 * Option actions
 *
 * Call order:
 *
 * OPTION_SAVE_QUEUE:	adds the item to the save queue
 * --> OPTION_SAVE:	modifies the state
 * --> OPTION_SAVE_SUCCESS: if all went well
 * --> OPTION_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail OPTION_SAVE_QUEUE is during the call to OPTION_SAVE,
 * as adding an item to the queue should never fail.
 */

export const OPTION_FETCH_ONE_QUEUE: any = 'OPTION_FETCH_ONE_QUEUE';
export const OPTION_FETCH_SUCCESS: any = 'OPTION_FETCH_SUCCESS';
export const OPTION_FETCH_FAILURE: any = 'OPTION_FETCH_FAILURE';
export const OPTION_FETCH_ONE_SUCCESS: any = 'OPTION_FETCH_ONE_SUCCESS';
export const OPTION_FETCH_ONE_FAILURE: any = 'OPTION_FETCH_ONE_FAILURE';

export const OPTION_SAVE: any = 'OPTION_SAVE';
export const OPTION_SAVE_QUEUE: any = 'OPTION_SAVE_QUEUE';
export const OPTION_SAVE_SUCCESS: any = 'OPTION_SAVE_SUCCESS';
export const OPTION_SAVE_FAILURE: any = 'OPTION_SAVE_FAILURE';

export const OPTION_SAVE_MANY: any = 'OPTION_SAVE_MANY';
export const OPTION_SAVE_MANY_QUEUE: any = 'OPTION_SAVE_MANY_QUEUE';
export const OPTION_SAVE_MANY_SUCCESS: any = 'OPTION_SAVE_MANY_SUCCESS';
export const OPTION_SAVE_MANY_FAILURE: any = 'OPTION_SAVE_MANY_FAILURE';

export const OPTION_REMOVE: any = 'OPTION_REMOVE';
export const OPTION_REMOVE_QUEUE: any = 'OPTION_REMOVE_QUEUE';
export const OPTION_REMOVE_SUCCESS: any = 'OPTION_REMOVE_SUCCESS';
export const OPTION_REMOVE_FAILURE: any = 'OPTION_REMOVE_FAILURE';

export const OPTION_RESTORE: any = 'OPTION_RESTORE';
export const OPTION_RESTORE_QUEUE: any = 'OPTION_RESTORE_QUEUE';
export const OPTION_RESTORE_SUCCESS: any = 'OPTION_RESTORE_SUCCESS';
export const OPTION_RESTORE_FAILURE: any = 'OPTION_RESTORE_FAILURE';

export const OPTION_RESTORE_MANY: any = 'OPTION_RESTORE_MANY';
export const OPTION_REMOVE_MANY: any = 'OPTION_REMOVE_MANY';

/* Fetch actions */
export const fetchOptionSuccess = (options: Option[], partial: boolean, lastFetch: number) => ({type: OPTION_FETCH_SUCCESS, options, partial, lastFetch});
export const fetchOptionFailure = (err: any) => {
		console.error('OptionAction: fetchOptionFailure', err);
		return {type: OPTION_FETCH_FAILURE, err};
};
export const fetchOneOptionQueue = (optionId: string) => ({type: OPTION_FETCH_ONE_QUEUE, optionId});
export const fetchOneOptionSuccess = (option: Option) => ({type: OPTION_FETCH_ONE_SUCCESS, option});
export const fetchOneOptionFailure = (id: string, err: any) => {
		console.error('OptionAction: fetchOneOptionFailure', err);
		return {type: OPTION_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveOption = (option: Option) => {
    // console.debug('⮂ OPTION_SAVE action', option?.id);
    return {type: OPTION_SAVE, option};
}
export const saveOptionQueue = (option: Option) => {
    // console.debug('⮂ OPTION_SAVE_QUEUE action', option?.id);
    return {type: OPTION_SAVE_QUEUE, option};
}
export const saveOptionSuccess = (option: Option) => {
    // console.debug('⮂ OPTION_SAVE_SUCCESS action', option?.id);
    return {type: OPTION_SAVE_SUCCESS, option};
}
export const saveOptionFailure = (option: Option, status: number, message: string) => {
    console.warn(`⮂ OPTION_SAVE_FAILURE error saving option: HTTP ${status}: ${message}`, option?.id);
    return {type: OPTION_SAVE_FAILURE, option, status, message};
};

/* SaveMany actions */
export const saveManyOptions = (options: Option[]) => {
    // console.debug('⮂ OPTION_SAVE_MANY action', options?.map(option => option?.id).join(','));
    return {type: OPTION_SAVE_MANY, options};
}
export const saveManyOptionsQueue = (options: Option[]) => {
    // console.debug('⮂ OPTION_SAVE_MANY_QUEUE action', options?.map(option => option.id).join(','));
    return {type: OPTION_SAVE_MANY_QUEUE, options};
}

export const saveManyOptionsSuccess = (options: Option[]) => {
    // console.debug('⮂ OPTION_SAVE_MANY_SUCCESS action', options?.map(option => option.id).join(','));
    return {type: OPTION_SAVE_MANY_SUCCESS, options};
}
export const saveManyOptionsFailure = (options: Option[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_OPTIONS_FAILURE Error saving options: HTTP ${status}: ${message}`, options?.map(option => option.id).join(','));
		return {type: OPTION_SAVE_MANY_FAILURE, options, status, message};
};

/* Remove actions */
export const removeOption = (option: Option) => ({ type: OPTION_REMOVE, option });
export const removeOptionQueue = (option: Option) => ({ type: OPTION_REMOVE_QUEUE, option });
export const removeOptionSuccess = (option: Option) => ({ type: OPTION_REMOVE_SUCCESS, option });
export const removeOptionFailure = (option: Option, status: number, message: string) => {
	console.error(`Redux: removeOptionFailure Error removing option: HTTP ${status}: ${message}`);
	return ({ type: OPTION_REMOVE_FAILURE, option, status, message });
};

/* Restore actions */
export const restoreOption = (option: Option) => ({ type: OPTION_RESTORE, option });
export const restoreOptionQueue = (option: Option) => ({ type: OPTION_RESTORE_QUEUE, option });
export const restoreOptionSuccess = (option: Option) => ({ type: OPTION_RESTORE_SUCCESS, option });
export const restoreOptionFailure = (option: Option, status: number, message: string) => {
	console.error(`Redux: restoreOptionFailure Error restoring option: HTTP ${status}: ${message}`);
	return ({ type: OPTION_RESTORE_FAILURE, option, status, message });
};

/* RestoreMany actions */
export const restoreManyOptions = (options: Option[]) => ({ type: OPTION_RESTORE_MANY, options });

/* RemoveMany actions */
export const removeManyOptions = (options: Option[]) => ({ type: OPTION_REMOVE_MANY, options });